// extracted by mini-css-extract-plugin
module.exports = {"name":"EventRow_name__3xwaP","time":"EventRow_time__2Caxk","icon":"EventRow_icon__3UweS"};